import { RawRigTableEvent } from '../../utils/type'

export const emptyRawRigTableEvent: RawRigTableEvent = {
    id: null,
    intervention_id: null,
    end: null,
    state: null,
    type: 'MAIN',
    start: null,
    status: null
}
